/* tslint:disable */
/* eslint-disable */
/**
 * FileIngestionService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMFileIngestionServiceFileTypesDataType = {
    Text: 'Text',
    Boolean: 'Boolean',
    Integer: 'Integer',
    Float: 'Float',
    Timestamp: 'Timestamp',
} as const;

export type RHIMFileIngestionServiceFileTypesDataType = typeof RHIMFileIngestionServiceFileTypesDataType[keyof typeof RHIMFileIngestionServiceFileTypesDataType];


export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCommonMetadataKeysDto {
    'metadataKeys': Array<string>;
}
export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto {
    'name': string;
    'expectedExtensions': Array<string>;
    'enrichmentRules': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationEnrichmentRuleDto>;
    'requiredMetadataKeys': Array<string>;
}
export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto {
    'id': string;
    'name': string;
    'expectedExtensions': Array<string>;
    'enrichmentRules': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationEnrichmentRuleDto>;
    'requiredMetadataKeys': Array<string>;
}
export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationListDto {
    'id': string;
    'name': string;
    'expectedExtensions': Array<string>;
    'enrichmentRules': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationEnrichmentRuleDto>;
    'requiredMetadataKeys': Array<string>;
    'status': RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationStatus;
}



export const RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationStatus = {
    MissingParserConfiguration: 'MissingParserConfiguration',
    Ready: 'Ready',
} as const;

export type RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationStatus = typeof RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationStatus[keyof typeof RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationStatus];


export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationEnrichmentRuleDto {
    'metadataKey': string;
    'pattern'?: string | null;
    'value': string;
}
export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDto {
    'name': string;
    'fields': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoField>;
    'tables': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoTable>;
}
export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoColumn {
    'name': string;
    'dataType': RHIMFileIngestionServiceFileTypesDataType;
}


export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoField {
    'name': string;
    'dataType': RHIMFileIngestionServiceFileTypesDataType;
}


export interface RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoTable {
    'name': string;
    'columns': Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDtoColumn>;
}
/**
 * Describes a column in table
 */
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationColumnDefinitionDto {
    /**
     * Identifier (internal name) of the column
     */
    'id': string;
    /**
     * Display name of the column
     */
    'displayName': string;
    /**
     * Data type of the column
     */
    'dataType': RHIMFileIngestionServiceFileTypesDataType;
    /**
     * Description of the column\'s content
     */
    'description'?: string | null;
    /**
     * Set of allowed values for this column. Only applicable to RHIM.FileIngestionService.FileTypes.DataType.Text columns.
     */
    'allowedValues'?: Array<string> | null;
    /**
     * Abbreviation of the unit of the column (optional) <br />  e.g.: kg, °C, m
     */
    'unit'?: string | null;
    /**
     * Category used to group columns (optional)
     */
    'category'?: string | null;
    /**
     * Sub category used to group columns together with RHIM.FileIngestionService.V1.HarmonizationConfiguration.ColumnDefinitionDto.Category (optional)
     */
    'subCategory'?: string | null;
}


export interface RHIMFileIngestionServiceV1HarmonizationConfigurationColumnSourceDto {
    'file': string;
    'tableName': string;
    'columnName': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationColumnTargetDto {
    'tableName': string;
    'columnName': string;
    'dataType'?: RHIMFileIngestionServiceFileTypesDataType | null;
}


export interface RHIMFileIngestionServiceV1HarmonizationConfigurationComplexMappingExpressionDto {
    'target': RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDtoTarget;
    'expression': string;
}
/**
 * Describes a field
 */
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFieldDefinitionDto {
    /**
     * Identifier (internal name) of the field
     */
    'id': string;
    /**
     * Display name of the field
     */
    'displayName': string;
    /**
     * Data type of the field
     */
    'dataType': RHIMFileIngestionServiceFileTypesDataType;
    /**
     * Description of the field\'s content
     */
    'description'?: string | null;
    /**
     * Set of allowed values for this field. Only applicable to RHIM.FileIngestionService.FileTypes.DataType.Text columns.
     */
    'allowedValues'?: Array<string> | null;
    /**
     * Abbreviation of the unit of the field (optional) <br />  e.g.: kg, °C, m
     */
    'unit'?: string | null;
    /**
     * Category used to group columns (optional)
     */
    'category'?: string | null;
    /**
     * Sub category used to group columns together with RHIM.FileIngestionService.V1.HarmonizationConfiguration.FieldDefinitionDto.Category (optional)
     */
    'subCategory'?: string | null;
}


export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFieldSourceDto {
    'file': string;
    'fieldName': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFieldTargetDto {
    'fieldName': string;
    'dataType'?: RHIMFileIngestionServiceFileTypesDataType | null;
}


export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFileByIndexDto {
    'index': number;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFileByNameDto {
    'file': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDto {
    'alias': string;
    'fileType': string;
    'scope': RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDto;
    'rowFilters': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationRowFilterExpressionDto>;
    'mappings': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDtoMappingsInner>;
    'passthroughContentFromInputFile'?: string | null;
}
/**
 * @type RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDtoMappingsInner
 */
export type RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDtoMappingsInner = RHIMFileIngestionServiceV1HarmonizationConfigurationComplexMappingExpressionDto | RHIMFileIngestionServiceV1HarmonizationConfigurationOneToOneMappingExpressionDto;

export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto {
    'name': string;
    'mergeOutputFiles': boolean;
    'isActive': boolean;
    'fileMappings': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDto>;
    'inputFileTypeIds': Array<string>;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto {
    'id': string;
    'name': string;
    'mergeOutputFiles': boolean;
    'isActive': boolean;
    'fileMappings': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationFileMappingDto>;
    'inputFileTypeIds': Array<string>;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDto {
    'id': string;
    'name': string;
    'isActive': boolean;
    'inputFileTypes': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDtoInputFileTypeListDto>;
    'outputFileTypes': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDtoOutputFileTypeListDto>;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDtoInputFileTypeListDto {
    'id': string;
    'customerFileTypeName': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDtoOutputFileTypeListDto {
    'fileTypeName': string;
    'alias': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizedFileStructureDto {
    'name': string;
    'description'?: string | null;
    'isExtensible': boolean;
    'fields': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationFieldDefinitionDto>;
    'tables': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationTableDefinitionDto>;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDto {
    'target': RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDtoTarget;
}
/**
 * @type RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDtoTarget
 */
export type RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDtoTarget = RHIMFileIngestionServiceV1HarmonizationConfigurationColumnTargetDto | RHIMFileIngestionServiceV1HarmonizationConfigurationFieldTargetDto;

export interface RHIMFileIngestionServiceV1HarmonizationConfigurationOneToOneMappingExpressionDto {
    'target': RHIMFileIngestionServiceV1HarmonizationConfigurationMappingExpressionDtoTarget;
    'source': RHIMFileIngestionServiceV1HarmonizationConfigurationOneToOneMappingExpressionDtoAllOfSource;
}
/**
 * @type RHIMFileIngestionServiceV1HarmonizationConfigurationOneToOneMappingExpressionDtoAllOfSource
 */
export type RHIMFileIngestionServiceV1HarmonizationConfigurationOneToOneMappingExpressionDtoAllOfSource = RHIMFileIngestionServiceV1HarmonizationConfigurationColumnSourceDto | RHIMFileIngestionServiceV1HarmonizationConfigurationFieldSourceDto;

export interface RHIMFileIngestionServiceV1HarmonizationConfigurationRowFilterExpressionDto {
    'tableName': string;
    'expression': string;
    'discardFileIfEmpty': boolean;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDto {
    'fileScope': RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoFileScope;
    'tableScope': RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoTableScope;
}
/**
 * @type RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoFileScope
 */
export type RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoFileScope = RHIMFileIngestionServiceV1HarmonizationConfigurationFileByIndexDto | RHIMFileIngestionServiceV1HarmonizationConfigurationFileByNameDto;

/**
 * @type RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoTableScope
 */
export type RHIMFileIngestionServiceV1HarmonizationConfigurationScopeDtoTableScope = RHIMFileIngestionServiceV1HarmonizationConfigurationTableByIndexDto | RHIMFileIngestionServiceV1HarmonizationConfigurationTableByNameDto;

export interface RHIMFileIngestionServiceV1HarmonizationConfigurationSourceDto {
    'file': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationTableByIndexDto {
    'index': number;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationTableByNameDto {
    'tableName': string;
}
export interface RHIMFileIngestionServiceV1HarmonizationConfigurationTableDefinitionDto {
    'name': string;
    'description'?: string | null;
    'columns': Array<RHIMFileIngestionServiceV1HarmonizationConfigurationColumnDefinitionDto>;
}
export interface RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDto {
    'id': string;
    'fileType': string;
    'fields': { [key: string]: RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDtoFieldValueDto; };
    'temporaryDownloadLink': RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDtoTemporaryDownloadLinkDto;
}
export interface RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDtoFieldValueDto {
    'type': RHIMFileIngestionServiceFileTypesDataType;
    'value'?: any | null;
}


export interface RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDtoTemporaryDownloadLinkDto {
    'uri': string;
    'expiresOn': string;
}
export interface RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto {
    'parserType': string;
    'parserConfiguration': any;
}
export interface RHIMFileIngestionServiceV1ParserParserListDto {
    'displayName': string;
    'parserType': string;
}
export interface RHIMFileIngestionServiceV1ParserParserSchemaDto {
    'schema': any;
}
export interface RHIMFileIngestionServiceV1UploadUploadResponseDto {
    /**
     * Can be used to track the uploaded file during the harmonization
     */
    'fileIngressId': string;
}

/**
 * CustomerFileTypeConfigurationApi - axios parameter creator
 */
export const CustomerFileTypeConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CreateCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerFileTypeConfiguration: async (customerId: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createCustomerFileTypeConfiguration', 'customerId', customerId)
            const localVarPath = `/customerfiletypeconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DeleteCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerFileTypeConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomerFileTypeConfiguration', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerFileTypeConfiguration', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfigurationCommonMetadataKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeConfigurationCommonMetadataKeys: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customerfiletypeconfiguration/metadatakeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetCustomerFileTypeStructure
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeStructure: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerFileTypeStructure', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}/structure`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerFileTypeConfiguration: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('listCustomerFileTypeConfiguration', 'customerId', customerId)
            const localVarPath = `/customerfiletypeconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerFileTypeConfiguration: async (id: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomerFileTypeConfiguration', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerFileTypeConfigurationApi - functional programming interface
 */
export const CustomerFileTypeConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerFileTypeConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CreateCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerFileTypeConfiguration(customerId: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerFileTypeConfiguration(customerId, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.createCustomerFileTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary DeleteCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerFileTypeConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.deleteCustomerFileTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerFileTypeConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.getCustomerFileTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfigurationCommonMetadataKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerFileTypeConfigurationCommonMetadataKeys(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCommonMetadataKeysDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerFileTypeConfigurationCommonMetadataKeys(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.getCustomerFileTypeConfigurationCommonMetadataKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetCustomerFileTypeStructure
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerFileTypeStructure(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerFileTypeStructure(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.getCustomerFileTypeStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomerFileTypeConfiguration(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomerFileTypeConfiguration(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.listCustomerFileTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary UpdateCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerFileTypeConfiguration(id: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerFileTypeConfiguration(id, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerFileTypeConfigurationApi.updateCustomerFileTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerFileTypeConfigurationApi - factory interface
 */
export const CustomerFileTypeConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerFileTypeConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary CreateCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerFileTypeConfiguration(customerId: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto> {
            return localVarFp.createCustomerFileTypeConfiguration(customerId, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DeleteCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomerFileTypeConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto> {
            return localVarFp.getCustomerFileTypeConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetCustomerFileTypeConfigurationCommonMetadataKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeConfigurationCommonMetadataKeys(options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCommonMetadataKeysDto> {
            return localVarFp.getCustomerFileTypeConfigurationCommonMetadataKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetCustomerFileTypeStructure
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFileTypeStructure(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationParsedFileStructureDto> {
            return localVarFp.getCustomerFileTypeStructure(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListCustomerFileTypeConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerFileTypeConfiguration(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationListDto>> {
            return localVarFp.listCustomerFileTypeConfiguration(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateCustomerFileTypeConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerFileTypeConfiguration(id: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationDto> {
            return localVarFp.updateCustomerFileTypeConfiguration(id, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerFileTypeConfigurationApi - object-oriented interface
 */
export class CustomerFileTypeConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary CreateCustomerFileTypeConfiguration
     * @param {string} customerId Format - uuid.
     * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCustomerFileTypeConfiguration(customerId: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).createCustomerFileTypeConfiguration(customerId, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DeleteCustomerFileTypeConfiguration
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).deleteCustomerFileTypeConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetCustomerFileTypeConfiguration
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerFileTypeConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).getCustomerFileTypeConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetCustomerFileTypeConfigurationCommonMetadataKeys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerFileTypeConfigurationCommonMetadataKeys(options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).getCustomerFileTypeConfigurationCommonMetadataKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetCustomerFileTypeStructure
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerFileTypeStructure(id: string, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).getCustomerFileTypeStructure(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListCustomerFileTypeConfiguration
     * @param {string} customerId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCustomerFileTypeConfiguration(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).listCustomerFileTypeConfiguration(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateCustomerFileTypeConfiguration
     * @param {string} id Format - uuid.
     * @param {RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomerFileTypeConfiguration(id: string, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return CustomerFileTypeConfigurationApiFp(this.configuration).updateCustomerFileTypeConfiguration(id, rHIMFileIngestionServiceV1CustomerFileTypeConfigurationCustomerFileTypeConfigurationCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HarmonizationConfigurationApi - axios parameter creator
 */
export const HarmonizationConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CreateHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarmonizationConfiguration: async (customerId: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createHarmonizationConfiguration', 'customerId', customerId)
            const localVarPath = `/harmonizationconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DeleteHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHarmonizationConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteHarmonizationConfiguration', 'id', id)
            const localVarPath = `/harmonizationconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizationConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHarmonizationConfiguration', 'id', id)
            const localVarPath = `/harmonizationconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetHarmonizedFileTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizedFileTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/harmonizationconfiguration/harmonizedfiletypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHarmonizationConfiguration: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('listHarmonizationConfiguration', 'customerId', customerId)
            const localVarPath = `/harmonizationconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarmonizationConfiguration: async (id: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHarmonizationConfiguration', 'id', id)
            const localVarPath = `/harmonizationconfiguration/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HarmonizationConfigurationApi - functional programming interface
 */
export const HarmonizationConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HarmonizationConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CreateHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHarmonizationConfiguration(customerId: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHarmonizationConfiguration(customerId, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.createHarmonizationConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary DeleteHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHarmonizationConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.deleteHarmonizationConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarmonizationConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.getHarmonizationConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetHarmonizedFileTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarmonizedFileTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizedFileStructureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarmonizedFileTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.getHarmonizedFileTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHarmonizationConfiguration(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHarmonizationConfiguration(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.listHarmonizationConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary UpdateHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHarmonizationConfiguration(id: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHarmonizationConfiguration(id, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizationConfigurationApi.updateHarmonizationConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HarmonizationConfigurationApi - factory interface
 */
export const HarmonizationConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HarmonizationConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary CreateHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHarmonizationConfiguration(customerId: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto> {
            return localVarFp.createHarmonizationConfiguration(customerId, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DeleteHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHarmonizationConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto> {
            return localVarFp.getHarmonizationConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetHarmonizedFileTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizedFileTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizedFileStructureDto>> {
            return localVarFp.getHarmonizedFileTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListHarmonizationConfiguration
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHarmonizationConfiguration(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationListDto>> {
            return localVarFp.listHarmonizationConfiguration(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateHarmonizationConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHarmonizationConfiguration(id: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationDto> {
            return localVarFp.updateHarmonizationConfiguration(id, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HarmonizationConfigurationApi - object-oriented interface
 */
export class HarmonizationConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary CreateHarmonizationConfiguration
     * @param {string} customerId Format - uuid.
     * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createHarmonizationConfiguration(customerId: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).createHarmonizationConfiguration(customerId, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DeleteHarmonizationConfiguration
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).deleteHarmonizationConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetHarmonizationConfiguration
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHarmonizationConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).getHarmonizationConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetHarmonizedFileTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHarmonizedFileTypes(options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).getHarmonizedFileTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListHarmonizationConfiguration
     * @param {string} customerId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listHarmonizationConfiguration(customerId: string, options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).listHarmonizationConfiguration(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateHarmonizationConfiguration
     * @param {string} id Format - uuid.
     * @param {RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto} [rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateHarmonizationConfiguration(id: string, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto?: RHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return HarmonizationConfigurationApiFp(this.configuration).updateHarmonizationConfiguration(id, rHIMFileIngestionServiceV1HarmonizationConfigurationHarmonizationConfigurationCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HarmonizedFilesApi - axios parameter creator
 */
export const HarmonizedFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetHarmonizedFile
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizedFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHarmonizedFile', 'id', id)
            const localVarPath = `/harmonizedfiles/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HarmonizedFilesApi - functional programming interface
 */
export const HarmonizedFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HarmonizedFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetHarmonizedFile
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHarmonizedFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHarmonizedFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HarmonizedFilesApi.getHarmonizedFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HarmonizedFilesApi - factory interface
 */
export const HarmonizedFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HarmonizedFilesApiFp(configuration)
    return {
        /**
         * 
         * @summary GetHarmonizedFile
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHarmonizedFile(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1HarmonizationHarmonizedFileDto> {
            return localVarFp.getHarmonizedFile(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HarmonizedFilesApi - object-oriented interface
 */
export class HarmonizedFilesApi extends BaseAPI {
    /**
     * 
     * @summary GetHarmonizedFile
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHarmonizedFile(id: string, options?: RawAxiosRequestConfig) {
        return HarmonizedFilesApiFp(this.configuration).getHarmonizedFile(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParserApi - axios parameter creator
 */
export const ParserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetParserConfigurationSchema
         * @param {string} parserType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParserConfigurationSchema: async (parserType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parserType' is not null or undefined
            assertParamExists('getParserConfigurationSchema', 'parserType', parserType)
            const localVarPath = `/parser/{parserType}`
                .replace('{parserType}', encodeURIComponent(String(parserType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListParser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParserApi - functional programming interface
 */
export const ParserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetParserConfigurationSchema
         * @param {string} parserType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParserConfigurationSchema(parserType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1ParserParserSchemaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParserConfigurationSchema(parserType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParserApi.getParserConfigurationSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListParser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMFileIngestionServiceV1ParserParserListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParserApi.listParser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParserApi - factory interface
 */
export const ParserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParserApiFp(configuration)
    return {
        /**
         * 
         * @summary GetParserConfigurationSchema
         * @param {string} parserType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParserConfigurationSchema(parserType: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1ParserParserSchemaDto> {
            return localVarFp.getParserConfigurationSchema(parserType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListParser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParser(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMFileIngestionServiceV1ParserParserListDto>> {
            return localVarFp.listParser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParserApi - object-oriented interface
 */
export class ParserApi extends BaseAPI {
    /**
     * 
     * @summary GetParserConfigurationSchema
     * @param {string} parserType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getParserConfigurationSchema(parserType: string, options?: RawAxiosRequestConfig) {
        return ParserApiFp(this.configuration).getParserConfigurationSchema(parserType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListParser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listParser(options?: RawAxiosRequestConfig) {
        return ParserApiFp(this.configuration).listParser(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParserConfigurationApi - axios parameter creator
 */
export const ParserConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParserConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParserConfiguration', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}/parserconfiguration`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto} [rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setParserConfiguration: async (id: string, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto?: RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setParserConfiguration', 'id', id)
            const localVarPath = `/customerfiletypeconfiguration/{id}/parserconfiguration`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParserConfigurationApi - functional programming interface
 */
export const ParserConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParserConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParserConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParserConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParserConfigurationApi.getParserConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary SetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto} [rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setParserConfiguration(id: string, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto?: RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setParserConfiguration(id, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParserConfigurationApi.setParserConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParserConfigurationApi - factory interface
 */
export const ParserConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParserConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary GetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParserConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto> {
            return localVarFp.getParserConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SetParserConfiguration
         * @param {string} id Format - uuid.
         * @param {RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto} [rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setParserConfiguration(id: string, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto?: RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto> {
            return localVarFp.setParserConfiguration(id, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParserConfigurationApi - object-oriented interface
 */
export class ParserConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary GetParserConfiguration
     * @param {string} id Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getParserConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return ParserConfigurationApiFp(this.configuration).getParserConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SetParserConfiguration
     * @param {string} id Format - uuid.
     * @param {RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto} [rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setParserConfiguration(id: string, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto?: RHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options?: RawAxiosRequestConfig) {
        return ParserConfigurationApiFp(this.configuration).setParserConfiguration(id, rHIMFileIngestionServiceV1ParserConfigurationParserConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadApi - axios parameter creator
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to be the file. The fileName has to be set on the file part.  There always has to be a file part.  Also the order of the parts is important. Only the metadata before the first file is used.  If multiple files are send the first one is used.  There is a special metadata field called RHIM.FileIngestionService.V1.Upload.UploadController.TotalFileSizeKeyName which is used to  check if all of the content of the file is in this request or if the remaining content is send in chunks.  To upload these chunks the endpoint \"part/{fileIngressId}\" has to be used.
         * @summary Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to 
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postUploadCustomerid', 'customerId', customerId)
            const localVarPath = `/Upload/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @summary This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @param {string} fileIngressId Format - uuid. The file id to which this chunk should be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPartFileingressid: async (fileIngressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileIngressId' is not null or undefined
            assertParamExists('postUploadPartFileingressid', 'fileIngressId', fileIngressId)
            const localVarPath = `/Upload/part/{fileIngressId}`
                .replace('{fileIngressId}', encodeURIComponent(String(fileIngressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to be the file. The fileName has to be set on the file part.  There always has to be a file part.  Also the order of the parts is important. Only the metadata before the first file is used.  If multiple files are send the first one is used.  There is a special metadata field called RHIM.FileIngestionService.V1.Upload.UploadController.TotalFileSizeKeyName which is used to  check if all of the content of the file is in this request or if the remaining content is send in chunks.  To upload these chunks the endpoint \"part/{fileIngressId}\" has to be used.
         * @summary Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to 
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMFileIngestionServiceV1UploadUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.postUploadCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @summary This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @param {string} fileIngressId Format - uuid. The file id to which this chunk should be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadPartFileingressid(fileIngressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadPartFileingressid(fileIngressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.postUploadPartFileingressid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadApi - factory interface
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to be the file. The fileName has to be set on the file part.  There always has to be a file part.  Also the order of the parts is important. Only the metadata before the first file is used.  If multiple files are send the first one is used.  There is a special metadata field called RHIM.FileIngestionService.V1.Upload.UploadController.TotalFileSizeKeyName which is used to  check if all of the content of the file is in this request or if the remaining content is send in chunks.  To upload these chunks the endpoint \"part/{fileIngressId}\" has to be used.
         * @summary Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to 
         * @param {string} customerId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMFileIngestionServiceV1UploadUploadResponseDto> {
            return localVarFp.postUploadCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @summary This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
         * @param {string} fileIngressId Format - uuid. The file id to which this chunk should be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPartFileingressid(fileIngressId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postUploadPartFileingressid(fileIngressId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 */
export class UploadApi extends BaseAPI {
    /**
     * Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to be the file. The fileName has to be set on the file part.  There always has to be a file part.  Also the order of the parts is important. Only the metadata before the first file is used.  If multiple files are send the first one is used.  There is a special metadata field called RHIM.FileIngestionService.V1.Upload.UploadController.TotalFileSizeKeyName which is used to  check if all of the content of the file is in this request or if the remaining content is send in chunks.  To upload these chunks the endpoint \"part/{fileIngressId}\" has to be used.
     * @summary Uploads a file to the hmd transfer storage of the customer.  The content has to be sent as multipart/form-data.  All the metadata has to be send first. Each metadata value has to be send in its own part,  where the name of a part is its key and the string content is its value.  The last part has to 
     * @param {string} customerId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUploadCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).postUploadCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
     * @summary This endpoint needs to be used if the upload happens in chunks.  The first chunk and metadata needs to be send to the other endpoint.  This endpoint then handles the chunks. The chunks are also send as multipart data request but  without any metadata and only a file section.
     * @param {string} fileIngressId Format - uuid. The file id to which this chunk should be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUploadPartFileingressid(fileIngressId: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).postUploadPartFileingressid(fileIngressId, options).then((request) => request(this.axios, this.basePath));
    }
}



